module.exports = __webpack_public_path__ + "img/MAIL_mob.46ec662d.png";